export const GANTT_VIEWER = "gantt-viewer";
